import styled from "styled-components";

export const VoucherImportPageStyle = styled.div`

`;
